import { render, staticRenderFns } from "./MachineRentStatus.vue?vue&type=template&id=2c2f30b1&"
import script from "./MachineRentStatus.vue?vue&type=script&lang=ts&"
export * from "./MachineRentStatus.vue?vue&type=script&lang=ts&"
import style0 from "./MachineRentStatus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports